<template>
  <v-autocomplete
    v-on="$listeners"
    v-bind="_attrs"
  >
    <!-- pass through scoped slots -->
    <template
      v-for="(_, scopedSlotName) of $scopedSlots"
      v-slot:[scopedSlotName]="scope"
    >
      <slot
        :name="scopedSlotName"
        v-bind="scope"
      />
    </template>

    <!-- pass through regular slots after scoped slots -->
    <!-- including the scope binding in regular slots doesn't seem to work. That's why this next block exists -->
    <template
      v-for="(_, slotName) of $slots"
      v-slot:[slotName]
    >
      <slot :name="slotName" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "DataSwitcher",
  inheritAttrs: false,
  computed: {
    _attrs() {
      const defaults = {
        'solo-inverted': true,
        'flat': true,
        'hide-details': true,
        'clearable': true,
        'prepend-inner-icon': 'mdi-magnify'
      };
      return {...defaults, ...this.$attrs};
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

::v-deep.theme--dark.v-input .v-input__control {
  .v-input__slot {
    background-color: #1A3B69
  }

  .v-select__slot {
    input::placeholder {
      color: $ads-white;
    }
  }
}

// focus state
::v-deep.theme--dark.v-input--is-focused .v-input__control {
  .v-input__slot {
    border: 2px solid $ads-blue-2-dark;
    // counter-act border change
    padding: 0px 10px;
    background-color: $ads-white !important;
  }

  .v-select__slot {
    input::placeholder {
      color: $ads-dark;
    }
  }
}
</style>

<style lang="scss">
@import "../../styles/variables.scss";

// menu is rendered outside of component scope
.v-menu__content.v-autocomplete__content .v-list {
  .v-list-item--link.v-list-item--active {
    background-color: $ads-light-10;

    &::before {
      // override existing semi-transparent background
      opacity: 0;
    }
  }

  .v-list-item--link.v-list-item--highlighted {
    background-color: $ads-custom-navy-2;

    &::before {
      opacity: 0;
    }
  }
}
</style>
